export const convertToNumber = (value) => {
  const stringValue = String(value || "");

  // Remove the £ symbol and convert to a number
  return parseFloat(stringValue.replace(/£/, "")) || 0;
};
